module.exports = __webpack_public_path__ + "img/banner.82f29a43.svg";